import { VEHICLES_REQUEST_FIELDS } from '@/constants/used-cars/used-cars.constants';
import { VehicleInfoTableOption } from '@/types/details-car/details-car.types';

export const infoTableOptions: VehicleInfoTableOption[] = [
  { id: 1, name: 'General', isSelected: true },
  { id: 2, name: 'Body', isSelected: false },
  { id: 3, name: 'Fuel & Efficiency', isSelected: false },
  { id: 4, name: 'Engine & Drivetrain', isSelected: false },
  { id: 5, name: 'Features', isSelected: false },
];

export const VEHICLE_REQUEST_FIELDS = [
  ...VEHICLES_REQUEST_FIELDS,
  'registration_date',
  'vin',
  'registration_number',
  'vehicle_description',
  'spec_body_colors.name',
  'spec_cylinders.value',
  'spec_litres_100km.float_value',
  'mm_code',
  'popularity',
  'is_konfidence',
  'duoporta_id',
];

export const DETAILED_VEHICLE_REQUEST_FIELDS = [
  ...VEHICLE_REQUEST_FIELDS,
  'disclaimer.text',
  'digital_twin_url',
];

export const VEHICLE_DETAILS_SECTION_ID = 'vehicle_details';
export const FINANCE_SECTION_ID = 'finance';
export const SAFETY_INSPECTION_SECTION_ID = 'safety_inspection';

export const navLinks = [
  {
    name: 'Vehicle Details',
    sectionId: VEHICLE_DETAILS_SECTION_ID,
  },
  {
    name: 'Finance',
    sectionId: FINANCE_SECTION_ID,
  },
  {
    name: 'Safety & Inspection',
    sectionId: SAFETY_INSPECTION_SECTION_ID,
  },
];
